import { useQueries } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Card, Spinner } from "../components/ui";

/** A count per entity. Deliberately cheap — it reads the `total` the list
 *  envelope already returns rather than adding a bespoke stats endpoint. */
export default function Dashboard() {
  const results = useQueries({
    queries: [
      {
        queryKey: ["regions", "count"],
        queryFn: () => api.regions.list({ limit: 1 }),
      },
      {
        queryKey: ["producers", "count"],
        queryFn: () => api.producers.list({ limit: 1 }),
      },
      {
        queryKey: ["bottles", "count"],
        queryFn: () => api.bottles.list({ limit: 1 }),
      },
      {
        queryKey: ["tasting-notes", "count"],
        queryFn: () => api.tastingNotes.list({ limit: 1 }),
      },
    ],
  });

  const cards = [
    { label: "Regions", to: "/regions", idx: 0 },
    { label: "Producers", to: "/producers", idx: 1 },
    { label: "Bottles", to: "/bottles", idx: 2 },
    { label: "Tasting Notes", to: "/tasting-notes", idx: 3 },
  ];

  if (results.some((r) => r.isLoading)) return <Spinner />;

  return (
    <div>
      <header className="mb-6">
        <h1 className="text-xl font-semibold">Cellar Book</h1>
        <p className="text-sm text-muted">Track every bottle in the restaurant cellar</p>
      </header>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map((c) => (
          <Link key={c.to} to={c.to}>
            <Card className="p-5 transition hover:border-brand">
              <p className="text-sm text-muted">{c.label}</p>
              <p className="mt-1 text-3xl font-semibold tabular-nums">
                {results[c.idx]?.data?.total ?? 0}
              </p>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
